"use strict";

(function () {
  'use strict';

  angular.module('lr.State').factory('StateFactory', StateFactory);
  StateFactory.$inject = ['$http', '$q', 'User', 'api', 'authErrors', '$filter'];
  /* @ngInject */

  function StateFactory($http, $q, User, api, authErrors, $filter) {
    var State = {};

    State.getOverallCount = function () {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        $http.post(api.proxy + '/Reservations/Property/State/Readiness/Overall/Count', {}).then(function (data) {
          deferred.resolve(data.data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };

    State.getCount = function (adminCustDataID, date) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        adminCustDataID = adminCustDataID || user.AdminCustDataID;
        var sendData = {
          AdminCustDataID: adminCustDataID,
          QueryDate: $filter('date')(date, 'M/d/yyyy')
        };
        $http.post(api.proxy + '/Reservations/Property/State/Readiness/Arrival/Count', sendData).then(function (data) {
          deferred.resolve(data.data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };

    State.flagProperty = function (property, flagState, reason) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        flagState = flagState;
        var data = {
          adminCustDataID: user.AdminCustDataID,
          pagedataid: property.pageDataID,
          NewFlagState: flagState,
          NewFlagReason: reason,
          overriddingResUserID: user.ResUserID,
          overriddingUsersIPAddress: user.ClientIP
        };
        $http.post(api.proxy + '/reservations/property/state/Override/Flag', data).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };

    State.getDetails = function (pageDataID) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        $http.get(api.proxy + '/Reservations/Property/State/Details/' + user.AdminCustDataID + '/' + pageDataID, {
          cache: true
        }).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };

    State.changeGuestState = function (transactionId, pageDataId, guestState) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        $http.post(api.proxy + '/Reservations/Property/State/Override/GuestState', {
          TransactionID: transactionId,
          PageDataID: pageDataId,
          LiveRezEventType: guestState
        }).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };

    var service = {
      State: State
    };
    return service; ////////////////
  }
})();